export default __webpack_public_path__ + "static/media/2019.431eed4a.png";